import axiosInstance from 'utils/axiosInstance';
import {
  ITransferHandler,
  TransferAccountDetails,
  TransferInitiationPayload,
  TransferUnderpayment,
} from '../types';

export class PayStackTransferHandler implements ITransferHandler {
  async initiateTransfer(
    payload: TransferInitiationPayload,
  ): Promise<TransferAccountDetails> {
    const response = await axiosInstance.post('/virtualAccounts', {
      transactionId: payload.transactionId,
      amount: payload.amount,
      email: payload.email,
    });
    return response.data;
  }

  /**
   * Paystack's payment reference is the Ceviant transaction id with its
   * first eight characters removed. This shaping previously lived in
   * PayWithTransfer and Payment.
   */
  getStatusUrl(transactionId: string): string {
    return `/transactions/${transactionId.slice(8)}`;
  }

  readStatus(data: any): string | undefined {
    return data?.transactionStatus;
  }

  readUnderpayment(data: any): TransferUnderpayment {
    return {
      amountReceived: readAmount(data?.amountReceived),
      outstandingAmount: readAmount(data?.outstandingAmount),
    };
  }
}

const readAmount = (value: unknown): number | undefined =>
  typeof value === 'number' ? value : undefined;
